import { render } from "./CopyActivityModal.vue?vue&type=template&id=16a4a071&scoped=true"
import script from "./CopyActivityModal.vue?vue&type=script&lang=js"
export * from "./CopyActivityModal.vue?vue&type=script&lang=js"

import "./CopyActivityModal.vue?vue&type=style&index=0&id=16a4a071&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\Peaco-v.1\\PEACO\\peacohrm-main\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16a4a071"]])

export default __exports__